"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PlusUser16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 12, viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6054 7.2118C13.4549 6.54027 14.0001 5.50063 14.0001 4.33366C14.0001 2.30861 12.3585 0.666992 10.3334 0.666992C8.30837 0.666992 6.66675 2.30861 6.66675 4.33366C6.66675 5.50063 7.21191 6.54027 8.06144 7.2118C6.53542 7.99156 5.46291 9.53233 5.34435 11.3337H6.6817C6.8501 9.46483 8.42073 8.00033 10.3334 8.00033C12.2461 8.00033 13.8167 9.46483 13.9851 11.3337H15.3225C15.2039 9.53233 14.1314 7.99157 12.6054 7.2118ZM10.3334 6.66699C11.6221 6.66699 12.6667 5.62232 12.6667 4.33366C12.6667 3.04499 11.6221 2.00033 10.3334 2.00033C9.04475 2.00033 8.00008 3.04499 8.00008 4.33366C8.00008 5.62232 9.04475 6.66699 10.3334 6.66699Z", fill: "#383F49", stroke: "#383F49", strokeWidth: 0.5 }),
        react_1.default.createElement("path", { d: "M2.66675 4.00033H4.00008V6.00033H6.00008V7.33366H4.00008V9.33366H2.66675V7.33366H0.666748V6.00033H2.66675V4.00033Z", fill: "#383F49", stroke: "#383F49", strokeWidth: 0.5 }));
}
function PlusUser16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PlusUser16Svg, Object.assign({}, svgProps)));
}
exports.default = PlusUser16;
//# sourceMappingURL=PlusUser16.js.map